import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

export const MobileMenuAccordionSection = ({ title, isOpen, onToggle, children, testId }) => (
  <div style={{ borderTop: '1px solid rgba(138,154,134,0.25)', paddingTop: '0.5rem', marginTop: '0.25rem' }}>
    <button
      type="button"
      onClick={onToggle}
      data-testid={testId}
      style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%',
        padding: '0.7rem 0.75rem', borderRadius: '0.6rem', fontSize: '0.8rem', fontWeight: 800,
        color: '#1B2A41', background: 'rgba(138,154,134,0.12)', border: 'none', cursor: 'pointer',
        textTransform: 'uppercase', letterSpacing: '0.04em'
      }}
    >
      <span>{title}</span>
      <motion.span animate={{ rotate: isOpen ? 180 : 0 }} transition={{ duration: 0.2 }} style={{ display: 'flex' }}>
        <ChevronDown size={16} />
      </motion.span>
    </button>
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.2 }}
          style={{ overflow: 'hidden' }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem', padding: '0.5rem 0 0.25rem' }}>
            {children}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);

export default MobileMenuAccordionSection;
